import axios from "axios";
import { apiRoot } from "@/config";

export const list = async () => await axios.get(`${apiRoot}/habits`);
export const create = async data => await axios.post(apiRoot + "/habits", data);
export const update = async ({ id, data }) => await axios.post(apiRoot + "/habits/" + id, data);